// extracted by mini-css-extract-plugin
var _1 = "zUjbDpbb56u15SaytOIS";
var _2 = "SnefHlJ94x1F8HdTQRdw";
var _3 = "DsM1gGOtYm5nm3ySBu_w";
var _4 = "yBeqajKYaaSPAzoZEAQY";
export { _1 as "beerList", _2 as "beerListContainer", _3 as "beers", _4 as "letterBoard" }
